import Conf from 'ui-config'
import axios from 'axios'

export const AuthAPI = {
  init: async function(params) {
    return await axios(Conf.HOST + Conf.LC_IP + '/lc/users/init', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(params),
    })
  },
  login: async function(params) {
    return await axios(Conf.HOST + Conf.LC_IP + '/lc/users/login', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(params),
    })
  },
  logout: async function(params) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/users/logout', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: params.ssid,
      },
      data: params,
    })
  },
  saml_check: async function(params) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/users/saml/login', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(params),
    })
  },
  validateToken: async function(token) {
    return await axios(
      Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/users/verify-sso-token/' + token,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    )
  },
  validateRedirctToken: async function(token) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/users/handoff/redeem', {
      method: 'POST',
      data: JSON.stringify({ token }),
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
  },
  invalidate: async function(params) {
    return await axios(
      Conf.HOST_S + Conf.CORE_IP + '/' + params.clusterId + '/api/session/invalidate',
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          SSID: params.SSID,
        },
        data: {},
      },
    )
  },
  getIdFromToken: async function(token) {
    return await axios(
      Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/verify-pass-token/' + token,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      },
    )
  },
  setPassword: async function(params) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/set_pass', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: params,
    })
  },
  resetPassword: async function() {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/reset_pass', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
  },
  resetUserPassword: async function(params, ssid) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/reset_user_pass', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: ssid,
      },
      data: params,
    })
  },
  validResetLink: async function(params, ssid) {
    return await axios(
      Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/valid_reset_link/' + params.token,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          SSID: ssid,
        },
        data: params,
      },
    )
  },
  changePassword: async function(params, ssid) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/users/change_password', {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: ssid,
      },
      data: params,
    })
  },
  clusters: async function(ssid) {
    return await axios(Conf.HOST + Conf.LC_IP + Conf.PORT_1 + '/lc/mgmt/cluster/list', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        SSID: ssid,
      },
    })
  },
}
export default AuthAPI
